'use client';

import {
  LoggerProvider as FELoggerProvider,
  registerGlobalHandlers,
  useLogger,
} from '@gfiber/fe-logger';
import type {ReactNode} from 'react';
import {useEffect, useRef} from 'react';

function LoggerHandler() {
  const feLogger = useLogger();
  const handlersRegistered = useRef(false);

  useEffect(() => {
    // register global handlers and ensure it only happens once
    if (!handlersRegistered.current && feLogger) {
      registerGlobalHandlers(feLogger);
      handlersRegistered.current = true;
    }
  }, [feLogger]);

  return null;
}

interface LoggerProviderProps {
  children: ReactNode;
}

export function LoggerProvider({children}: LoggerProviderProps) {
  const gfiberBaseUri = process.env.NEXT_PUBLIC_GFIBER_ORIGIN;
  const isNotProd = process.env.NEXT_PUBLIC_TARGET_ENV !== 'prod';

  if (!gfiberBaseUri) {
    if (isNotProd) {
      console.warn(
        'LoggerProvider: NEXT_PUBLIC_GFIBER_ORIGIN is not set. Logger will be disabled.',
      );
    }
    return <>{children}</>;
  }

  const config = {
    endpoint: `${gfiberBaseUri}/events/v1/log`,
    service: 'support',
    version: '1.0.0', // TODO: Figure out how to set this dynamically later
    debug: isNotProd,
  };

  return (
    <FELoggerProvider config={config}>
      <LoggerHandler />
      {children}
    </FELoggerProvider>
  );
}
